import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.Help.title',
    defaultMessage: 'Help',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.Help.subtitle',
    defaultMessage: 'We are here to help!\nPlease contact us at any time and we will get back to you as soon as possible.\n\nClick on the button below or follow these instructions:\n• Redirect back to the dashboard and click on “Contact Us” in the left hand side navigation bar.\n• Your favorite email application will open, and you can send us a message.',
  },
  sendEmail: {
    id: 'containers.SupplierProfile.components.Help.sendEmail',
    defaultMessage: 'Send Email',
  },
  helpEmail: {
    id: 'containers.SupplierProfile.components.Help.helpEmail',
    defaultMessage: 'studio@voicearchive.com',
  },
})
